var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5C5.32843 4.5 6 3.82843 6 3C6 2.17157 5.32843 1.5 4.5 1.5C3.67157 1.5 3 2.17157 3 3C3 3.82843 3.67157 4.5 4.5 4.5Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.25H2.25C2.05109 5.25 1.86032 5.32902 1.71967 5.46967C1.57902 5.61032 1.5 5.80109 1.5 6V11.25H3V16.5H6V11.25H7.5V6C7.5 5.80109 7.42098 5.61032 7.28033 5.46967C7.13968 5.32902 6.94891 5.25 6.75 5.25Z",
    fill: "#7A5AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.5C13.5784 4.5 14.25 3.82843 14.25 3C14.25 2.17157 13.5784 1.5 12.75 1.5C11.9216 1.5 11.25 2.17157 11.25 3C11.25 3.82843 11.9216 4.5 12.75 4.5Z",
    fill: "#7A5AF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1575 5.79752C15.1121 5.6353 15.0135 5.49307 14.8774 5.39375C14.7414 5.29443 14.5758 5.2438 14.4075 5.25002H11.0325C10.8642 5.2438 10.6986 5.29443 10.5626 5.39375C10.4265 5.49307 10.3279 5.6353 10.2825 5.79752L9 10.5H10.5L9.75 13.5H11.25V16.5H14.25V13.5H15.75L15 10.5H16.5L15.1575 5.79752Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentPurple);
export default __webpack_public_path__ + "static/media/parent_purple.1bbe9e0c3d8686b5ecb57c6a0c48c234.svg";
export { ForwardRef as ReactComponent };